import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import SearchBars from 'components/SearchBars';
import SearchBarWrapper from 'components/SearchBarWrapper';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import ClientsTable, { CLIENT_COLUMNS, CLIENT_CARDS, CLIENT_MIN_TABLE_WIDTH } from 'components/Tables/Clients';
import * as DataList from 'components/DataList';
import Page from 'components/Page';
import Card from 'components/Card';
import Sticky from 'react-stickynode';
import styled from '@emotion/styled';
import ClientsSideBar from 'components/Client/ClientsSideBar';

const PageWrapGray = styled('div')`
  padding: 5px 5px 0px 5px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);  
`

@inject('store', 'clientStore', 'viewStore') @observer
class ClientsIndexPage extends Component {

  @observable visible = true;

  render() {
    let content;
    let {
      clientStore,
      viewStore,
      clientStore: {
        clients: {
          isLoading,
          isError
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = (
        <DataList.Loading
          columns={CLIENT_COLUMNS}
          cards={CLIENT_CARDS}
          minTableWidth={CLIENT_MIN_TABLE_WIDTH}
          noun="clients"
        />
      );
    }
    if (isError && !isLoading) {
      content = <DataList.LoadError noun="clients" onRetry={() => clientStore.loadClients()} />;
    }
    if (!isError && !isLoading) {
      content = <ClientsTable />
    }
    return (
      <div>
        <Helmet>
          <title>Clients | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters"> 
          <div className="col-lg-2 sidebar-responsive">
            <ClientsSideBar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
            <Sticky enabled={true} top={0} innerZ={9}>
              <SearchBarWrapper>
                <SearchBars.Client key={viewStore.listFiltersVersion} />
              </SearchBarWrapper>
            </Sticky>
            <Page style={{ paddingTop: 0 }}>
              <Card>
                {content}
              </Card>
            </Page>
            </PageWrapGray>
          </div>
        </div>
      </div>
      
    )
  }

};

export default ClientsIndexPage;